module.exports = __webpack_public_path__ + "static/media/yoga.38082a7b.svg";